<template>
  <div class="module demandInfoNews">
    <div class="news-content">
      <el-carousel :interval="5000" :autoplay="false" :arrow="list.length > 0 ? 'always' : 'never'" indicator-position="none">
        <div v-if="list.length == 0" class="empty">
          <!-- 暂无数据 -->
          <img src="../../assets/noMesge.jpg" style="width: 200px;" />
        </div>
        <el-carousel-item v-for="item in list" :key="item.uuid">
          <div class="news-item">
            <div class="picture">
              <img :src="item.pictureUrl" alt="" />
            </div>
            <div class="text-wrap">
              <div class="title">{{item.title}}</div>
              <div class="summary">{{ item.summary }}</div>
              <div class="row">
                <div class="date">{{item.publishDate}}</div>
                <div class="btn" @click="getNewsItemDetail(item.uuid)">查看详情>></div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import {
  queryNewText,
  getNewsProgramTreeList,
  getBannerList
} from "../../utils/interface";
import { mapState, mapMutations } from "vuex";

export default {
  //   新闻
  name: "news",
  components: {},
  data() {
    return {
      showNoNews: false,
      clickNum: null,
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "NEWS_BANNER",
      bannerList: [
        {
          value: ""
        }
      ],
      solutionList: [],
      newList: [
        {
          title: "",
          children: [
            {
              title: ""
            }
          ]
        }
      ],
      parkActiveIndex: 0,
      soluIndex: null,
      soluIndex2: null,
      // 分页
      current: 1,
      pageSize: 10,
      total: 0,
      soluTabsIndex: null,
      newListIndex: null,
      programUuid: "",
      status: "PUBLISH",
      opends: ["0"],
      title: "",
      timer: null,
      setIn: null, // 定时器
      titleMessage: "",
      indexElmenu: false,
      defaultActive: "1",
      list: [],
      allSearch: false // 是否全局搜索
    };
  },
  watch: {
  },
  created() {
    this.getSolutionList();
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor"
    })
  },
  mounted() {
    window.scrollTo(0, 0);
    // if (this.bannerList.length !== 0) {
    window.addEventListener("resize", () => {
      this.imgHeight = this.$refs.image[0].height;
    });
    // }
  },
  methods: {
    handleOpen(key, keyPath) {
      this.newListIndex = key;
      this.programUuid = this.newList[key].uuid;
      this.soluTabsIndex = undefined;
      this.getSolutionList();
    },
    handleClose(key, keyPath) {
      this.newListIndex = undefined;
      this.soluTabsIndex = undefined;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getSolutionList();
    },


    /* 获取左侧列表 */
    getLeftList() {
      let params = {
        ignoreOrigin: "ASSOCIATION",
        current: 1,
        pageSize: 10
      };
      getNewsProgramTreeList(params).then(res => {
        this.newList = res;
      });
    },
    ...mapMutations(["searchMsgVuex"]),
    fn(index) {
      this.clickNum = index;
    },
    getSolutionList() {
      return new Promise((reslove, reject) => {
        let params = {
          // name:'',
          status: "PUBLISH",
          programUuid: 'ff80808190bb39250199f03e515b00ae', //this.programUuid,
          title: this.title,
          // programName:this.programName,
          current: this.current,
          pageSize: this.pageSize
        };
        queryNewText(params).then(res => {
          if (res.success) {
            this.list = res.data;
            this.total = res.total;
            if (this.total > 0) {
              this.showNoNews = false;
            } else {
              this.showNoNews = true;
            }
            reslove();
          } else {
            this.showNoNews = true;
            reslove();
          }
        });
      });
    },
    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "newDetails",
        params: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    },
    findAll() {
      this.programUuid = null;
      this.newListIndex = null;
      this.soluTabsIndex = null;
      this.getSolutionList();
      this.newList.forEach((news, t) => {
        if (news.children != null) {
          news.children.forEach((item, tIndex) => {
            item.active = false;
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.module {
  width: 100%;
  height: 466px;
  background: url('~@/assets/image/demandInfo_news_bg.png') no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 350;
  color: #2B2B2B;
}

.demandInfoNews { 
  /deep/ .el-carousel__arrow {
    border: 1px solid #2D50A1;
    transform: unset;
  }
  /deep/ .el-carousel__arrow .el-icon-arrow-left, /deep/.el-carousel__arrow .el-icon-arrow-right {
    color: #2D50A1;
    font-weight: 600;
  }
  /deep/ .el-carousel__arrow--left {
    top: 0;
    right: 48px;
    left: unset;
  }
  /deep/  .el-carousel__arrow--right {
    right: 0px;
    top: 0;
  } 
}
.news-content {
  padding: 32px;
  width: 1300px;
  height: 333px;
  box-sizing: border-box;
  border-radius: 12px;
  opacity: 0.8;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  .news-item {
    display: flex;
  }
  .picture {
    flex-shrink: 0;
    margin-right: 26px;
    width: 425px;
    height: 269px;
    border-radius: 12px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text-wrap {
    flex-grow: 1;
    width: calc(100% - 475px);
  }
  .title {
    width: calc(100% - 120px);
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .summary {
    height: 129px;
    overflow: hidden;
    margin-bottom: 34px;
    line-height: 178%;
    display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
    -webkit-box-orient: vertical; /* 垂直排列 */
    -webkit-line-clamp: 4; /* 限制显示两行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
  }
  .row {
    display: flex;
    justify-content: space-between;
  }
  .btn {
    color: #2D50A1;
    cursor: pointer;
  }
}
.blue {
  color: #2d50a1;
}

</style>



// WEBPACK FOOTER //
// src/components/newsConsult/demandInfoNews.vue